export const LISTPRODUCTS = "LISTPRODUCTS"
export const LISTPRODUCTS_FAILURE = "LISTPRODUCTS_FAILURE"
export const ADDCART="ADDCART";
export const ADDFAVOURITE = "ADDFAVOURITE"
export const UPDATECART = "UPDATECART"
export const UPDATEORDER="UPDATEORDER"
export const PUSH_TO_ORDER = "PUSH_TO_ORDER"
export const REMOVE_ORDER = "REMOVE_ORDER"
export const NULL_ORDER = "NULL_ORDER"
export const VALUESEARCH = "VALUESEARCH"